import { axiosClient } from './axiosInstance';
import { UCL } from '../core/UserClientLibs';

const post = async (url, body) => {
    const headers = {
        mode: 'cors',
        'Content-Type': 'application/json',
        'X-Token': await UCL.GetIdTokenValidatedAsync(),
        Authorization: await UCL.BuildBearerAccessTokenAsync(),
    };

    return axiosClient.post(`${url}`, body, { headers })
        .then(handle)
        .catch(handleError)
};

const get = async (url, customHandler, customErrorHandler) => {
    const headers = {
        mode: 'cors',
        'Content-Type': 'application/json',
        'X-Token': await UCL.GetIdTokenValidatedAsync(),
        Authorization: await UCL.BuildBearerAccessTokenAsync()
    };
    return axiosClient.get(`${url}`, { headers })
        .then(customHandler ? customHandler : handle)
        .catch(customErrorHandler ? customErrorHandler : handleError)
};


const handle = (response) => {
    return response.data
}

const handleError = (error) => {
    return new Promise((resolve, reject) => {
        let message;
        switch (error.response.status) {
            case 401:
                message = `Se requiere autenticación. Por favor ingrese sus credenciales nuevamente - (status code: ${error.response.status})`;
                UCL.LogoutAsync({ embedShortCircuit: true, redirect: `login`, isVoluntary: false })
                break;
            case 402:
                break;
            case 403:
                message = `No posee los permisos necesarios para acceder al recurso solicitado. Por favor ingrese sus credenciales nuevamente - (status code: ${error.response.status})`;
                break;
            case 404:
                message = `No existe el recurso solicitado. Por favor intentelo nuevamente más tarde - (status code: ${error.response.status})`;
                break;
            case 400:
            case 500:
            case 'parsererror':
            case 'timeout':
            case 'abort':
            case 0:
            default:
                message =
                    'Ocurrió un error inesperado. Por favor intentelo nuevamente más tarde.';
        }
        reject(message);
    });
}

export default { post, get };



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/ApiService.js